import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpResponseValidator2d6ie1tmzg8fi as HttpResponseValidator,
  get_ExpectSuccessAttributeKey20jj5fup38v1g as get_ExpectSuccessAttributeKey,
} from './HttpCallValidator.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { save1y71vsgu0wj47 as save } from '../call/SavedCall.mjs';
import {
  bodyAsTextn7mkdszticiw as bodyAsText,
  HttpResponse1532ob1hsse1y as HttpResponse,
} from '../statement/HttpResponse.mjs';
import { MalformedInputExceptionbvc6h5ij0ias as MalformedInputException } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER;
}
var LOGGER;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, ($this$HttpResponseValidator) => {
    $this$HttpResponseValidator.e5t_1 = _this__u8e3s4.t5m_1;
    $this$HttpResponseValidator.f5t(addDefaultResponseValidation$lambda$slambda_0());
    return Unit_instance;
  });
}
var ResponseExceptionClass;
function ResponseException() {
  if (ResponseExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static l5t(response, cachedResponseText) {
        var $this = this.o('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"');
        captureStack($this, $this.k5t_1);
        $this.j5t_1 = response;
        return $this;
      }
    }
    initMetadataForClass($, 'ResponseException');
    ResponseExceptionClass = $;
  }
  return ResponseExceptionClass;
}
var RedirectResponseExceptionClass;
function RedirectResponseException() {
  if (RedirectResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      static t5t(response, cachedResponseText) {
        var $this = this.l5t(response, cachedResponseText);
        captureStack($this, $this.s5t_1);
        $this.r5t_1 = 'Unhandled redirect: ' + response.i5o().b5o().j5o().g56_1 + ' ' + response.i5o().b5o().k5o().toString() + '. ' + ('Status: ' + response.r5o().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.r5t_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'RedirectResponseException');
    RedirectResponseExceptionClass = $;
  }
  return RedirectResponseExceptionClass;
}
var ClientRequestExceptionClass;
function ClientRequestException() {
  if (ClientRequestExceptionClass === VOID) {
    class $ extends ResponseException() {
      static b5u(response, cachedResponseText) {
        var $this = this.l5t(response, cachedResponseText);
        captureStack($this, $this.a5u_1);
        $this.z5t_1 = 'Client request(' + response.i5o().b5o().j5o().g56_1 + ' ' + response.i5o().b5o().k5o().toString() + ') ' + ('invalid: ' + response.r5o().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.z5t_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ClientRequestException');
    ClientRequestExceptionClass = $;
  }
  return ClientRequestExceptionClass;
}
var ServerResponseExceptionClass;
function ServerResponseException() {
  if (ServerResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      static j5u(response, cachedResponseText) {
        var $this = this.l5t(response, cachedResponseText);
        captureStack($this, $this.i5u_1);
        $this.h5u_1 = 'Server error(' + response.i5o().b5o().j5o().g56_1 + ' ' + response.i5o().b5o().k5o().toString() + ': ' + (response.r5o().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.h5u_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ServerResponseException');
    ServerResponseExceptionClass = $;
  }
  return ServerResponseExceptionClass;
}
var addDefaultResponseValidation$lambda$slambdaClass;
function addDefaultResponseValidation$lambda$slambda() {
  if (addDefaultResponseValidation$lambda$slambdaClass === VOID) {
    class $ {
      *k5u(response, $completion) {
        var expectSuccess = response.i5o().c5o().i4r(get_ExpectSuccessAttributeKey());
        if (!expectSuccess) {
          get_LOGGER().a4y('Skipping default response validation for ' + response.i5o().b5o().k5o().toString());
          return Unit_instance;
        }
        var statusCode = response.r5o().t58_1;
        var originCall = response.i5o();
        if (statusCode < 300 || originCall.c5o().k4r(get_ValidateMark())) {
          return Unit_instance;
        }
        // Inline function 'kotlin.apply' call
        var this_0 = yield* save(originCall, $completion);
        this_0.c5o().l4r(get_ValidateMark(), Unit_instance);
        var exceptionCall = this_0;
        var exceptionResponse = exceptionCall.b5m();
        var tmp;
        try {
          tmp = yield* bodyAsText(exceptionResponse, VOID, $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof MalformedInputException()) {
            var _unused_var__etf5q3 = $p;
            tmp_0 = '<body failed decoding>';
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        var exceptionResponseText = tmp;
        var exception = (300 <= statusCode ? statusCode <= 399 : false) ? RedirectResponseException().t5t(exceptionResponse, exceptionResponseText) : (400 <= statusCode ? statusCode <= 499 : false) ? ClientRequestException().b5u(exceptionResponse, exceptionResponseText) : (500 <= statusCode ? statusCode <= 599 : false) ? ServerResponseException().j5u(exceptionResponse, exceptionResponseText) : ResponseException().l5t(exceptionResponse, exceptionResponseText);
        get_LOGGER().a4y('Default response validation for ' + response.i5o().b5o().k5o().toString() + ' failed with ' + exception.toString());
        throw exception;
      }
      od(p1, $completion) {
        return this.k5u(p1 instanceof HttpResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    addDefaultResponseValidation$lambda$slambdaClass = $;
  }
  return addDefaultResponseValidation$lambda$slambdaClass;
}
function addDefaultResponseValidation$lambda$slambda_0() {
  var i = new (addDefaultResponseValidation$lambda$slambda())();
  var l = (response, $completion) => i.k5u(response, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    ValidateMark = new (AttributeKey())(name, tmp$ret$1);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
//region block: exports
export {
  addDefaultResponseValidation as addDefaultResponseValidation1d06vtgr9flaj,
};
//endregion

//# sourceMappingURL=DefaultResponseValidation.mjs.map
